import React, { createContext, useContext, useReducer, useMemo } from "react";
import LoadedState from "./loadedState";
import reducer from "./reducers";
import { appStateSchema } from "shared/datamodel/schemas/app-state";
import { MondayUserBoardPermissions } from "frontend/services/monday-api-service";

export type { DispatchEvent } from "./actions";
export { Action } from "./actions";

function createInitialState() {
  return appStateSchema.parse({
    isLoggedIn: false,
    user: null,
    userState: LoadedState.loading,
    account: null,
    boardsState: LoadedState.initial,
    boards: [],
    usersState: LoadedState.initial,
    users: new Map(),
    teams: [],
    teamsState: LoadedState.initial,
    mondayBoardAccessPermission: MondayUserBoardPermissions.view,
  });
}

const StateContext = createContext<any>(null);

// eslint-disable-next-line react/prop-types
export function StateProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, createInitialState());
  const value = useMemo(() => [state, dispatch], [state, dispatch]);
  return <StateContext.Provider value={value}>{children}</StateContext.Provider>;
}

export function useStateValue() {
  return useContext(StateContext);
}
